import React from 'react';
import { Field, Form } from 'react-final-form';
import { Button, Spinner } from 'reactstrap';
import CustomInputField from '../../../components/form/CustomInputField';
import { useDict } from '../../../contexts/LanguageContext';
import { postSendResetPasswordEmail } from '../src/authApis';
import toast from 'react-hot-toast';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import ROUTE_NAME from '../../../routes/RouteName';

const ForgotPasswordForm = () => {
    const dict = useDict();
    const [isLoading, setIsLoading] = useState(false);

    const forgotPasswordValidate = (values) => {
        const errors = {};
        if (!values.email) {
            errors.email = dict.emailEmpty;
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = dict.emailInvalid;
        }
        return errors;
    };

    const submitSendResetPasswordEmail = async (values) => {
        setIsLoading(true);
        await postSendResetPasswordEmail(values);
        toast.success(dict.sendResetPasswordEmailSuccessMessage, {
            duration: 5000,
            id: dict.sendResetPasswordEmailSuccessMessage,
        });

        setIsLoading(false);
    };

    return (
        <Form
            validate={forgotPasswordValidate}
            initialValues={{ email: '' }}
            onSubmit={submitSendResetPasswordEmail}
        >
            {({ handleSubmit }) => (
                <form className="form" onSubmit={handleSubmit}>
                    <div className="forgot-password-text">
                        {dict.forgotPasswordText1}
                    </div>
                    <div className="form__form-group">
                        <div className="form__form-group-field">
                            <Field
                                name="email"
                            >
                                {({ input, meta }) => (
                                    <CustomInputField
                                        input={input}
                                        meta={meta}
                                        type="email"
                                        placeholder={dict.email}
                                    />
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="account__btns">
                        <Button
                            color="primary"
                            className="btn account__btn rounded"
                            type="submit"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <Spinner size="sm" color="orange" />
                            ) : (
                                dict.sendPasswordResetLink
                            )}
                        </Button>
                    </div>
                    <div className="forgot-password-text mb-2">
                        {dict.forgotPasswordText2}
                    </div>
                    <div className="account__btns m-0">
                        <Link to={ROUTE_NAME.HOME} className="btn account__btn btn-outline-primary rounded m-0">
                            {dict.logIn}
                        </Link>
                    </div>
                </form>
            )}
        </Form>
    );
};

export default ForgotPasswordForm;
